type TOrderFormValues = {
  price: string
  comment: string
  date: string | null
}

export const orderFormDefaultValues: TOrderFormValues = {
  price: '',
  comment: '',
  date: null,
}
